import React from 'react';
import { motion } from 'framer-motion';
import { XCircle, CheckCircle2 } from 'lucide-react';
const comparisons = [{
  bad: '3-5 hs/semana buscando actividades en internet',
  good: '10 min/semana mirando la secuencia del tomo'
}, {
  bad: 'Siempre las mismas fotocopias de siempre',
  good: '60+ secuencias y fichas nuevas listas'
}, {
  bad: 'Alumnos que no comprenden por falta de progresión',
  good: 'Progresión didáctica trimestral estructurada'
}, {
  bad: 'Sin alineación clara a los NAP',
  good: 'Cada secuencia explícitamente alineada al CFE'
}, {
  bad: 'Evaluaciones inventadas a último momento',
  good: 'Exámenes trimestrales con rúbricas y claves'
}, {
  bad: 'Carpeta didáctica desorganizada',
  good: 'Documentación lista para cualquier supervisión'
}, {
  bad: 'Planificación que no se sostiene en el tiempo',
  good: 'Sistema de 40 semanas resuelto desde el inicio'
}, {
  bad: 'Fin de año sin evidencia de progreso',
  good: 'Fichas del alumno como portafolio de aprendizaje'
}];
export const CostComparison = () => {
  return <section className="py-20 bg-white" data-id="element-36">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-37">
        <div className="text-center mb-16" data-id="element-38">
          <h2 className="text-sm font-bold text-brand-orange tracking-widest uppercase mb-2" data-id="element-39">
            LA REALIDAD
          </h2>
          <h3 className="text-3xl md:text-4xl font-heading font-bold text-gray-900" data-id="element-40">
            ¿Cuánto te cuesta NO tenerlo?
          </h3>
        </div>

        <div className="bg-cream-dark rounded-3xl overflow-hidden shadow-sm border border-gray-100" data-id="element-41">
          <div className="grid grid-cols-1 md:grid-cols-2" data-id="element-42">
            {/* Sin el Pack */}
            <div className="p-8 md:p-10 bg-red-50/50" data-id="element-43">
              <h4 className="text-xl font-bold text-red-800 mb-8 flex items-center gap-2 justify-center md:justify-start" data-id="element-44">
                <XCircle className="text-red-500" data-id="element-45" /> Sin el Pack
              </h4>
              <ul className="space-y-6" data-id="element-46">
                {comparisons.map((item, i) => <li key={i} className="flex items-start gap-3 text-red-900/70" data-id="element-47">
                    <XCircle size={20} className="flex-shrink-0 mt-0.5 text-red-300" data-id="element-48" />
                    <span className="text-sm md:text-base" data-id="element-49">{item.bad}</span>
                  </li>)}
              </ul>
            </div>

            {/* Con el Pack */}
            <div className="p-8 md:p-10 bg-brand-green text-white relative" data-id="element-50">
              <div className="absolute top-0 right-0 w-32 h-32 bg-white/5 rounded-bl-full" data-id="element-51"></div>
              <h4 className="text-xl font-bold text-brand-gold mb-8 flex items-center gap-2 justify-center md:justify-start relative z-10" data-id="element-52">
                <CheckCircle2 className="text-brand-gold" data-id="element-53" /> Con el Pack
              </h4>
              <ul className="space-y-6 relative z-10" data-id="element-54">
                {comparisons.map((item, i) => <li key={i} className="flex items-start gap-3 text-cream/90" data-id="element-55">
                    <CheckCircle2 size={20} className="flex-shrink-0 mt-0.5 text-brand-gold" data-id="element-56" />
                    <span className="text-sm md:text-base font-medium" data-id="element-57">
                      {item.good}
                    </span>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
};